import { Box, Container, Typography } from '@mui/material';

import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useStore } from '../store/context';

import UserDetailsDialog from '../components/dialog/UserDetailsDialog';
import { ProfileData } from '../store/UserStore';
import UserLogDetailsTable from '../components/tables/UserLogDetailsTable';
import UserTable from '../components/tables/UserTable';

const MaexchenUsersPage = observer((): JSX.Element => {
  const { userStore } = useStore();
  const [selectedUser, setselectedUser] = useState<ProfileData | null>(null);

  const [infoDialogOpen, setInfoDialog] = useState<boolean>(false);

  const handleInfoDialogSave = () => {
    setInfoDialog(false);
  };

  return (
    <Container sx={{ width: `calc(100% - ${240}px)`, ml: `${240}px` }}>
      <UserDetailsDialog
        profileData={selectedUser}
        open={infoDialogOpen}
        onClose={() => setInfoDialog(false)}
        onSave={handleInfoDialogSave}
      />
      <Box
        component="main"
        sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}
      >
        <Typography variant="h4">Logs</Typography>
      </Box>
      <Box style={{ display: 'flex', flexDirection: 'row' }}>
        <UserTable
          users={userStore?.userProfiles || []}
          onRowClick={setselectedUser}
          onInfoClick={() => setInfoDialog(true)}
        />
        <UserLogDetailsTable userItem={selectedUser} />
      </Box>
    </Container>
  );
});

export default MaexchenUsersPage;
